document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="ArticleImageGallery-"]').forEach(function (root) {
    if (!root || root.dataset.galleryInit === 'true') return;

    const items = Array.from(root.querySelectorAll('.gallery-item'));
    const lightbox = root.querySelector('.gallery-lightbox');
    if (!items.length || !lightbox) return;

    const img = lightbox.querySelector('.gallery-lightbox__img');
    const closeBtn = lightbox.querySelector('.gallery-lightbox__close');
    const overlay = lightbox.querySelector('.gallery-lightbox__overlay');
    const prevBtn = lightbox.querySelector('.gallery-lightbox__nav.prev');
    const nextBtn = lightbox.querySelector('.gallery-lightbox__nav.next');

    let currentIndex = 0;
    root.dataset.galleryInit = 'true';

    function updateImage() {
      img.src = items[currentIndex].dataset.full;
    }

    function openLightbox(index) {
      currentIndex = index;
      updateImage();
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.hidden = true;
      img.src = '';
      document.body.style.overflow = '';
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + items.length) % items.length;
      updateImage();
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % items.length;
      updateImage();
    }

    items.forEach(function (item, index) {
      item.addEventListener('click', function () {
        openLightbox(index);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (overlay) overlay.addEventListener('click', closeLightbox);
    if (prevBtn) prevBtn.addEventListener('click', showPrev);
    if (nextBtn) nextBtn.addEventListener('click', showNext);

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showPrev();
      if (e.key === 'ArrowRight') showNext();
    });
  });
});